import React from "react";
import { Provider } from "react-redux";
import store from "./redux/store";
import { CONTRASENA_NIVEL1, CONTRASENA_NIVEL2 } from "@env";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { NavigationContainer } from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import LoginScreen from "./screens/LoginScreen";
import ScanScreen from "./screens/ScanScreen";
import InfoScreen from "./screens/InfoScreen";
import TimeAndStatusScreen from "./screens/TimeAndStatusScreen";
import QualityReceptionScreen from "./screens/QualityReceptionScreen";
import StoneDeliveryScreen from "./screens/StoneDeliveryScreen";
import TimeWorkScreen from "./screens/TimeWorkScreen";
import CrimpingScreen from "./screens/CrimpingScreen";
import HeaderTitle from "./components/Common/ComponentHeaderTitle.js";
import { MaterialIcons } from "@expo/vector-icons";
import ProblemQualityScreen from "./screens/ProblemQualityScreen";
import FornitureDeliveryScreen from "./screens/FornitureDeliveryScreen";
import AdminSettingScreen from "./screens/AdminSettingScreen";
import FoundryScreen from "./screens/FoundryScreen";
import DetailsScreen from "./screens/DetailsScreen";
import OverallStatus from "./screens/OverallStatusScreen";
import WeighingAdminSection from "./screens/WeighingAdminSection";
import FinalWeighingAdminSection from "./screens/FinalWeighingAdminSection";
import CompletedFoundries from "./screens/CompletedFoundries.js";
import IntermediateWeighing from "./screens/IntermediateWeighing";
import FindingsWeighingScreen from "./screens/FindingsWeighingScreen.js";
import MachiningScreen from "./screens/MachiningScreen";
import MultipleMOWork from "./screens/MultipleMOWork";
import PartsMovements from "./screens/PartsMovements";
import OperarioScreen from "./screens/OperarioScreen.js";
import AdminOperationScreen from "./screens/AdminOperationScreen.js";
import InformacionEnDetalle from "./components/CargaDeFabrica/ComponentInformacionEnDetalle.js";
import InitialWeighing from "./screens/InitialWeighing.js";
import InformeTiemposDiario from "./screens/informeTiemposDiario.js";
import AdminControllerOptions from "./screens/AdminControllerOptions.js";
import AdminQueryData from "./screens/AdminQueryData.js";
import AdminCenterData from "./screens/AdminCenterData.js";
import CargaDeFabrica from "./screens/CargaDeFabrica.js";
import StoneControl from "./screens/StoneControl.js";
import UserDocumentScreen from "./screens/UserDocumentScreen.js";
import ValidarPesos from "./screens/validarDatosCalidad.js";
import { Image, Platform } from "react-native";
import ComponentAsignaciones from "./components/Asignaciones/ComponentAsignaciones.js";
import ComponentRecuperacionMerma from "./components/Metales/ComponentRecuperacionMerma.js";
import ComponentControlOro from "./components/Common/ComponentControlOro.js";
import EntregaPiedrasScreen from "./screens/EntregaPiedrasScreen.js";
import { color } from "react-native-reanimated";
import ControlDeReparacionesScreen from "./screens/ControlDeReparacionesScreen.js";
import ControlDeTrabajoExterno from "./screens/ControlDeTrabajoExterno.js";
import RecoveryHandler from "./components/Common/ComponentRecoveryHandler";
import { backgroundColor2 } from "./constants/Constants.js";
import AssignmentPriceLinesReportScreen from "./screens/AssignmentPriceLinesReportScreen.js";

const Stack = createStackNavigator();

export default function App() {
  const headerStyles = {
    headerStyle: {
      backgroundColor: "#0a0a0a",
      height: 45,
      paddingVertical: 5,
      borderBottomWidth: 1,
      borderBottomColor: "#1c282d",
    },
    headerTintColor: "#e8ebed",
    headerTitleStyle: {
      fontFamily: "monospace",
      fontSize: 24,
      fontWeight: "bold",
      letterSpacing: 1.2,
      color: "#d9dde1",
      textShadowColor: "rgba(0, 0, 0, 0.4)",
      textShadowOffset: { width: 1, height: 2 },
      textShadowRadius: 4,
    },
  };

  const headerStylesGreen = {
    headerStyle: {
      backgroundColor: backgroundColor2,
      height: 55,
      paddingVertical: 5,
      borderBottomWidth: 0,
      shadowColor: backgroundColor2,
      shadowOffset: { width: 0, height: 5 },
      shadowOpacity: 0.2,
      shadowRadius: 6,
      elevation: 6,
    },
    headerTintColor: "#ffffff",
    headerTitleStyle: {
      fontFamily: "System",
      fontSize: 20,
      fontWeight: "600",
      letterSpacing: 0.3,
      color: "#ffffff",
    },

    headerLeftContainerStyle: {
      paddingLeft: 12,
    },
    headerRightContainerStyle: {
      paddingRight: 12,
    },
  };

  return (
    <Provider store={store}>
      <RecoveryHandler />
      <NavigationContainer>
        <Stack.Navigator initialRouteName='Login'>
          <Stack.Screen
            name='JTS'
            component={LoginScreen}
            options={{
              ...headerStyles,
              headerTitle: () => <HeaderTitle textKey='JTS' />,
            }}
          />
          <Stack.Screen
            name='Scan'
            component={ScanScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Scanner' />,
            }}
          />
          <Stack.Screen
            name='Info'
            component={InfoScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Piece Info' />,
            }}
          />
          <Stack.Screen
            name='TimeAndStatus'
            component={TimeAndStatusScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Time And Status' />,
            }}
          />
          <Stack.Screen
            name='Incidences quality'
            component={ProblemQualityScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Quality Incidents' />,
            }}
          />
          <Stack.Screen
            name='Quality / Reception'
            component={QualityReceptionScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Quality / Reception' />,
            }}
          />
          <Stack.Screen
            name='Stone delivery'
            component={StoneDeliveryScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Gemstone Delivery' />,
            }}
          />
          <Stack.Screen
            name='Deliver Stones'
            component={EntregaPiedrasScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Deliver Gems' />,
            }}
          />
          <Stack.Screen
            name='WorkingTimes'
            component={TimeWorkScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Working Times' />,
            }}
          />
          <Stack.Screen
            name='Crimping'
            component={CrimpingScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Stone Setting' />,
            }}
          />
          <Stack.Screen
            name='Delivery Forniture'
            component={FornitureDeliveryScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Findings Delivery' />,
            }}
          />
          <Stack.Screen
            name='Admin Setting'
            component={AdminSettingScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => {
                // Usar require() directamente - debería funcionar en desarrollo y producción
                // Si en producción la ruta es diferente, el bundler debería resolverla correctamente
                const logoSource = require("./assets/photopea.png");
                
                return (
                  <Image
                    source={logoSource}
                    style={{ width: 130, height: 100, resizeMode: "contain" }}
                  />
                );
              },
              headerTitleAlign: "center",
            }}
          />
          <Stack.Screen
            name='Foundry'
            component={FoundryScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Casting' />,
            }}
          />
          <Stack.Screen
            name='Details'
            component={DetailsScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Details' />,
            }}
          />
          <Stack.Screen
            name='Overall status'
            component={OverallStatus}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Overall status' />,
            }}
          />
          <Stack.Screen
            name='Classification weighing'
            component={WeighingAdminSection}
            options={{
              ...headerStylesGreen,
              headerTitle: () => (
                <HeaderTitle textKey='Post-Casting Weighing' />
              ),
            }}
          />
          <Stack.Screen
            name='Completed foundries'
            component={CompletedFoundries}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Completed Casting' />,
            }}
          />
          <Stack.Screen
            name='Final weighing'
            component={FinalWeighingAdminSection}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Final weighing' />,
            }}
          />
          <Stack.Screen
            name='Intermediate weighing'
            component={IntermediateWeighing}
            options={{
              ...headerStylesGreen,
              headerTitle: () => (
                <HeaderTitle textKey='Intermediate weighing' />
              ),
            }}
          />
          <Stack.Screen
            name='Findings Weighing'
            component={FindingsWeighingScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Findings Weighing' />,
            }}
          />
          <Stack.Screen
            name='Machining'
            component={MachiningScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Piece Machining' />,
            }}
          />
          <Stack.Screen
            name='Screen work'
            component={MultipleMOWork}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Screen work' />,
            }}
          />
          <Stack.Screen
            name='Parts Movements'
            component={PartsMovements}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Piece Movements' />,
            }}
          />
          <Stack.Screen
            name='Operator Panel'
            component={OperarioScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Operator Dashboard' />,
            }}
          />
          <Stack.Screen
            name='Operator administration panel'
            component={AdminOperationScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Admin Operator Panel' />,
            }}
          />
          <Stack.Screen
            name='Asignaciones'
            component={ComponentAsignaciones}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Task Assignments' />,
            }}
          />

          <Stack.Screen
            name='Rec. de Merma'
            component={ComponentRecuperacionMerma}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Rec. de Merma' />,
            }}
          />
          <Stack.Screen
            name='Control Oro'
            component={ComponentControlOro}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Gold Control' />,
            }}
          />
          <Stack.Screen
            name='Initial Weight'
            component={InitialWeighing}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Initial Weight' />,
            }}
          />
          <Stack.Screen
            name='Daily Time Report'
            component={InformeTiemposDiario}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Daily Time Report' />,
            }}
          />
          <Stack.Screen
            name='Usuarios'
            component={AdminControllerOptions}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Users' />,
            }}
          />
          <Stack.Screen
            name='Control de datos'
            component={AdminQueryData}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Control de datos' />,
            }}
          />
          <Stack.Screen
            name='Administración'
            component={AdminCenterData}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Administración' />,
            }}
          />
          <Stack.Screen
            name='Carga de Fabrica'
            component={CargaDeFabrica}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Factory Load' />,
            }}
          />
          <Stack.Screen
            name='Piedras'
            component={StoneControl}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Stone Access Control' />,
            }}
          />
          <Stack.Screen
            name='Documentación'
            component={UserDocumentScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Piece Documents' />,
            }}
          />
          <Stack.Screen
            name='Validar calidad'
            component={ValidarPesos}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Quality Validation' />,
            }}
          />
          <Stack.Screen
            name='Ajustar Téoricos'
            component={InformacionEnDetalle}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Ajustar Téoricos' />,
            }}
          />
          <Stack.Screen
            name='Reparaciones'
            component={ControlDeReparacionesScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='Repairs' />,
            }}
          />
           <Stack.Screen
            name='Trabajo Externo'
            component={ControlDeTrabajoExterno}
            options={{
              ...headerStylesGreen,
              headerTitle: () => <HeaderTitle textKey='External work' />,
            }}
          />
          <Stack.Screen
            name='Assignment price lines report'
            component={AssignmentPriceLinesReportScreen}
            options={{
              ...headerStylesGreen,
              headerTitle: () => (
                <HeaderTitle textKey='Assignment price lines report' />
              ),
            }}
          />
        </Stack.Navigator>
      </NavigationContainer>
      <ToastContainer
        position='top-right'
        autoClose={4000}
        newestOnTop
        closeOnClick
        pauseOnHover
        theme='light'
        toastStyle={{
          borderRadius: 12,
          minHeight: 56,
          fontSize: 14,
          fontWeight: "500",
        }}
      />
    </Provider>
  );
}
